import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreatePrintedProposalInput,
    PrintedProposal,
    UpdatePrintedProposalInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class PrintedProposalService {
    private amplifyClient = generateClient();

    constructor() {}

    async listPrintedProposals(): Promise<PrintedProposal[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listPrintedProposals
                })
            ).data.listPrintedProposals.items;
            if (data) return data as PrintedProposal[];
        } catch (error) {
            console.error('Error finding PrintedProposal:', error);
            return null;
        }
    }

    async createPrintedProposal(
        input: CreatePrintedProposalInput
    ): Promise<PrintedProposal> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.createPrintedProposal,
                    variables: {
                        input
                    }
                })
            ).data.createPrintedProposal;
            if (data) return data as PrintedProposal;
        } catch (error) {
            console.error('Error creating PrintedProposal:', error);
            return null;
        }
    }
    async updatePrintedProposals(
        input: UpdatePrintedProposalInput
    ): Promise<PrintedProposal> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.updatePrintedProposal,
                    variables: {
                        input
                    }
                })
            ).data.updatePrintedProposal;
            if (data) return data as PrintedProposal;
        } catch (error) {
            console.error('Error update PrintedProposal:', error);
            return null;
        }
    }
}
